import { style } from 'typestyle';

export const container = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '0.75rem',
  width: '100%',
});

export const labelRow = style({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.5rem',
});
